interface AlarmOverviewProps {
  activeCount: number | null;
  onShowActive: () => void;
  reportDescriptionId: string;
}

/** TOM-673: one prominent count; freshness belongs to the shared header line. */
export function AlarmOverview({
  activeCount,
  onShowActive,
  reportDescriptionId,
}: AlarmOverviewProps) {
  const label = activeCount === 1 ? 'active alarm' : 'active alarms';
  return (
    <button
      className={`al-active-count${activeCount !== null && activeCount > 0 ? ' al-active-count--attention' : ''}`}
      type="button"
      data-testid="alarms-overview"
      aria-describedby={reportDescriptionId}
      onClick={onShowActive}
    >
      <strong className="al-active-count__number">{activeCount ?? '—'}</strong>
      <span className="al-active-count__copy">
        <span className="al-active-count__label">{label}</span>
        {activeCount === null ? (
          <span className="al-active-count__unknown">Not yet reported</span>
        ) : null}
      </span>
    </button>
  );
}
